// Carrousel de citations. Chaque citation est documentée (livre, notes
// publiées ou liste de diffusion). Ne rien ajouter sans source vérifiable.
const fr = {
  items: [
    {
      text: "La programmation, ce n'est pas ce que vous savez ; c'est ce que vous parvenez à comprendre par vous-même.",
      name: "Chris Pine",
      role: "Auteur de 'Learn to Program'",
      image: "/img/quotes/idea_lamp.webp",
    },
    {
      text: "La seule façon d'apprendre un nouveau langage de programmation est d'écrire des programmes dans ce langage.",
      name: "Brian Kernighan et Dennis Ritchie",
      role: "Auteurs de 'The C Programming Language'",
      image: "/img/quotes/software.webp",
    },
    {
      text: "N'importe quel imbécile peut écrire du code qu'un ordinateur comprend. Les bons programmeurs écrivent du code que les humains comprennent.",
      name: "Martin Fowler",
      role: "Auteur de 'Refactoring'",
      image: "/img/quotes/checking.webp",
    },
    {
      text: "Parler ne coûte rien. Montrez-moi le code.",
      name: "Linus Torvalds",
      role: "Créateur de Linux",
      image: "/img/quotes/solving.webp",
    },
    {
      text: "Les programmes doivent être écrits pour être lus par des personnes, et accessoirement pour être exécutés par des machines.",
      name: "Harold Abelson",
      role: "Co-auteur de 'Structure and Interpretation of Computer Programs'",
      image: "/img/quotes/books.webp",
    },
    {
      text: "La machine analytique tisse des motifs algébriques, comme le métier Jacquard tisse des fleurs et des feuilles.",
      name: "Ada Lovelace",
      role: "Première programmeuse de l'histoire",
      image: "/img/quotes/teaching.webp",
    },
    {
      text: "La fonction d'un bon logiciel est de faire paraître simple ce qui est complexe.",
      name: "Grady Booch",
      role: "Co-créateur d'UML",
      image: "/img/quotes/tools.webp",
    },
    {
      text: "La simplicité est une condition préalable de la fiabilité.",
      name: "Edsger W. Dijkstra",
      role: "Lauréat du prix Turing",
      image: "/img/quotes/idea_lamp.webp",
    },
  ],
};

export default fr;
